<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card" style="padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">{{ typeName }}基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="buyOrSale == 0 ? '采购付款单号' : '售出收款单号'" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成采购付款单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="buyOrSale == 0 ? '请款人' : '收款人'" prop="userName">
                <el-input v-model="form.userName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择所属科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="厂商信息" prop="manufacturerInfo">
                <el-select :disabled="!editMode" v-model="form.manufacturerInfo" style="width: 90%" filterable placeholder="请选择厂商信息" :filter-method="GetManufacturer" @change="manufacturerChange">
                  <el-option v-for="item in ManufacturerInfos" :key="item.type + '-' + item.id" :label="item.name" :value="item.type + '-' + item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="buyOrSale == 0 ? '付款总金额' : '收款总金额'" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" placeholder="根据详细信息金额求和汇总" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">退货详细信息</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column v-if="editMode" show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <el-table-column show-overflow-tooltip label="发票号码" align="center" min-width="140" prop="billNo" />
            <el-table-column show-overflow-tooltip label="发票代码" align="center" min-width="140" prop="billCode" />
            <el-table-column show-overflow-tooltip label="开票金额" align="center" min-width="140" prop="billAmount" :formatter="toDecimal4" />
            <el-table-column show-overflow-tooltip :label="buyOrSale == 0 ? '已付款金额' : '已收款金额'" align="center" min-width="140" prop="amountPaid" :formatter="toDecimal4" />
            <el-table-column show-overflow-tooltip :label="buyOrSale == 0 ? '待付款金额' : '待收款金额'" align="center" min-width="140" prop="unAmount" :formatter="toDecimal4" />
            <el-table-column show-overflow-tooltip :label="buyOrSale == 0 ? '本次付款金额' : '本次收款金额'" align="center" min-width="140" prop="amount" :formatter="toDecimal4">
              <template slot-scope="sScope">
                <template v-if="editMode">
                  <el-input-number v-model="sScope.row.amount" :min="0" :max="sScope.row.unAmount" :precision="4" :controls="false" placeholder="请填写付款金额" style="width: 90%" @change="autoTotalAmount"></el-input-number>
                </template>
                <template v-else>{{
                  toDecimal4(null, null, sScope.row.amount)
                }}</template>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center" min-width="240" prop="remark">
              <template slot-scope="sScope">
                <template v-if="editMode">
                  <el-input v-model="sScope.row.remark" />
                </template>
                <template v-else>{{ sScope.row.remark }}</template>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="请款详情信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="发票号码" prop="billNo">
                <el-select :disabled="!editMode" v-model="childForm.billNo" style="width: 90%" placeholder="请选择发票号码" :filter-method="GetInvoices" @change="billNoChange">
                  <el-option v-for="item in InvoicesOptions" :key="item.id" :label="item.no" :value="item.no"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发票代码" prop="billCode">
                <el-input disabled v-model="childForm.billCode" placeholder="请填写发票代码" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开票金额" prop="billAmount">
                <el-input-number disabled v-model="childForm.billAmount" :min="0" :precision="4" :controls="false" placeholder="请填写开票金额" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="已付款金额" prop="amountPaid">
                <el-input-number disabled v-model="childForm.amountPaid" :min="0" :precision="4" :controls="false" placeholder="请填写已付款金额" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="待付款金额" prop="unAmount">
                <el-input-number disabled v-model="childForm.unAmount" :min="0" :precision="4" :controls="false" placeholder="请填写待付款金额" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="本次付款金额" prop="amount">
                <el-input-number
                  v-model="childForm.amount"
                  :min="0"
                  :max="childForm.unAmount"
                  :precision="4"
                  :controls="false"
                  placeholder="请填写付款金额"
                  style="width: 90%"
                  @change="autoTotalAmount"
                ></el-input-number>
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input
                  :disabled="!editMode"
                  v-model="childForm.remark"
                  placeholder="请填写备注"
                  resize="none"
                  type="textarea"
                  :rows="5"
                  style="width:95%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetPurchasePaymentById,
  RejectPurchasePayment,
  SavePurchasePayment,
  GetSalesCollectionById,
  RejectSalesCollection,
  SaveSalesCollection,
  GetUninvoicedNoInfo,
  GetManufacturerInfos,
  GetPurchaseInvoices,
} from "@/api";
export default {
  mixins: [GetDataMixin],
  components: {},
  /** 定义属性 */
  data () {
    return {
      typeName: "请款",
      buyOrSale: 0,
      editMode: false,
      reject: RejectPurchasePayment,
      form: {
        relationNoIds: "",
        relationNoArr: [],
        relationNoInfos: [],
        totalNumber: 0,
        totalAmount: 0,
        unTotalNumber: 0,
        unTotalAmount: 0,
      },
      rules: {
        deptName: [
          { required: true, message: "所属科室不能为空", trigger: "blur" },
        ],
        manufacturerInfo: [
          { required: true, message: "厂商信息不能为空", trigger: "blur" },
        ],
      },
      ManufacturerInfos: [],
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      childForm: {},
      childFormRules: {
        amount: [
          { required: true, message: "本次付款金额不能为空", trigger: "blur" },
        ],
      },
      InvoicesOptions: [],
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.buyOrSale) {
        switch (query.buyOrSale) {
          case "0":
            this.typeName = "请款";
            this.buyOrSale = 0;
            this.reject = RejectPurchasePayment;
            break;
          case "1":
            this.typeName = "收款";
            this.buyOrSale = 1;
            this.reject = RejectSalesCollection;
            break;
        }
      }
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
      window.console.log(this.buyOrSale);
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      switch (this.buyOrSale) {
        case 0:
          GetPurchasePaymentById({ id }).then((res) => {
            this.form = res.returnData;
            switch (this.form.manufacturerInfoType) {
              case 0:
                // 供应商
                this.form.manufacturerInfo = this.form.supplierName;
                break;
              case 1:
                // 生产厂家
                this.form.manufacturerInfo = tthis.form.manufacturerName;
                break;
              case 2:
                // 维修厂商
                this.form.manufacturerInfo = tthis.form.repairManufacturerName;
                break;
            }
            this.initWorkFlowProperty(this.form);
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });
          });
          break;
        case 1:
          GetSalesCollectionById({ id }).then((res) => {
            this.form = res.returnData;
            switch (this.form.manufacturerInfoType) {
              case 0:
                // 供应商
                this.form.manufacturerInfo = this.form.supplierName;
                break;
              case 1:
                // 生产厂家
                this.form.manufacturerInfo = tthis.form.manufacturerName;
                break;
              case 2:
                // 维修厂商
                this.form.manufacturerInfo = tthis.form.repairManufacturerName;
                break;
            }
            this.initWorkFlowProperty(this.form);
            this.form.details.forEach((e, index) => {
              e.$index = index + 1;
            });
          });
          break;
      }
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        switch (this.buyOrSale) {
          case 0:
            SavePurchasePayment(this.form).then((res) => {
              this.$my_message(`执行成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.$router.push({ path: this.getMainPath(this.$route.path) });
            }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
            break;
          case 1:
            SaveSalesCollection(this.form).then((res) => {
              this.$my_message(`执行成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.$router.push({ path: this.getMainPath(this.$route.path) });
            }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
            break;
        }
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 初始化表单
     */

    resetForm () {
      this.form = {
        no: null,
        billCode: null,
        createdUserName: this.userInfo.name,
        userId: this.userInfo.id,
        userName: this.userInfo.name,
        deptName: this.userInfo.deptName,
        deptId: this.userInfo.deptId,
        type: null,
        category: null,
        totalNumber: null,
        totalAmount: null,
        unTotalAmount: null,
        unTotalNumber: null,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d} {h}:{m}:{s}"),
        date: null,
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    deptChange (val) {
      this.form.deptId = val;
    },
    manufacturerChange (val) {
      if (val) {
        this.form.manufacturerInfoId = val.split("-")[1];
        this.form.manufacturerInfoType = val.split("-")[0];
        this.GetInvoices();
      } else {
        this.form.manufacturerInfoId = "";
        this.form.manufacturerInfoType = "";
        this.InvoicesOptions = [];
      }
    },
    GetManufacturer (keyWord) {
      GetManufacturerInfos({
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 10000,
      }).then((res) => {
        this.ManufacturerInfos = res.returnData.data;
      });
    },
    /**
     * 获取发票
     */
    GetInvoices (keyWord) {
      GetPurchaseInvoices({
        pageIndex: 1,
        pageSize: 1000,
        keyWord: keyWord,
        buyOrSale: this.buyOrSale,
        manufacturerInfoId: this.form.manufacturerInfoId,
        manufacturerInfoType: this.form.manufacturerInfoType,
      }).then((res) => {
        this.InvoicesOptions = res.returnData.data;
      });
    },
    /**
     * 子表
     */
    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.childForm.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        fixedAssetNo: "",
        name: "",
        number: 0,
        price: 0,
        amount: 0,
        remark: "",
        state: 1,
        locationId: "",
        locationName: "",
        certId: "",
        certNo: "",
        manufacturerId: "",
        manufacturerInfo: "",
        brandId: "",
        brandName: "",
        details: [],
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.pushChildForm();
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) => e.$index == this.childForm.$index
        );
        if (item) {
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    billNoChange (e) {
      let item = this.InvoicesOptions.find((t) => t.no == e);
      if (item) {
        this.childForm.purcaseInvoiceId = item.id;
        this.childForm.billCode = item.billCode;
        this.childForm.billAmount = item.totalAmount;
        this.childForm.amountPaid = item.payAmount;
        this.childForm.unAmount = item.unTotalAmount;
      }
    },
    childNumberChange () {
      this.childForm.unBillNumber = this.childForm.number;
      this.autoAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalAmount = totalAmount;
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getDepts();
    this.GetManufacturer();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
